export { default } from './TextInput';
export type { TextInputProps } from './index.type';
